'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import dayjs from 'dayjs';
import React, { createContext, useState } from 'react';
import { useCountdown } from '@src/hooks/useCountDown';
export const CountdownContext = createContext<any>({});
interface CountdownWrapperProps {
  children: React.ReactNode;
  startTime: Date;
  endTime: Date;
  includedChildren: any[];
  completionMessage: string;
  builderBlock: any;
  behavior: 'static' | 'dynamic';
  dynamicMinutes: number;
  dynamicSeconds: number;
  dynamicDays: number;
  dynamicHours: number;
}
export default function CountdownWrapper(t0) {
  const $ = _c(23);
  const {
    children,
    startTime,
    endTime,
    includedChildren,
    builderBlock,
    completionMessage,
    behavior,
    dynamicDays,
    dynamicHours,
    dynamicMinutes,
    dynamicSeconds
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = () => !React.Children.count(children);
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldRenderBuilderBlocks = t1;
  let t2;
  if ($[2] !== dynamicDays || $[3] !== dynamicHours || $[4] !== dynamicMinutes || $[5] !== dynamicSeconds) {
    t2 = () => {
      const currentDate = dayjs();
      const date = currentDate.add(dynamicDays, "day").add(dynamicHours, "hour").add(dynamicMinutes, "minute").add(dynamicSeconds, "second");
      return date.toDate();
    };
    $[2] = dynamicDays;
    $[3] = dynamicHours;
    $[4] = dynamicMinutes;
    $[5] = dynamicSeconds;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const getDynamicTime = t2;
  let t3;
  if ($[7] !== getDynamicTime) {
    t3 = getDynamicTime();
    $[7] = getDynamicTime;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const [dynamicTime] = useState(t3);
  const currentEndTime = behavior === "dynamic" ? dynamicTime : endTime;
  const currentCountdown = useCountdown(currentEndTime) as any;
  const isCountdownFinished = currentCountdown.seconds < 0 || currentCountdown.minutes < 0 || currentCountdown.hours < 0 || currentCountdown.days < 0;
  let t4;
  if ($[9] !== currentCountdown || $[10] !== currentEndTime || $[11] !== startTime) {
    t4 = {
      startTime,
      endTime: currentEndTime,
      currentCountdown
    };
    $[9] = currentCountdown;
    $[10] = currentEndTime;
    $[11] = startTime;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== builderBlock?.id || $[14] !== children || $[15] !== completionMessage || $[16] !== includedChildren || $[17] !== isCountdownFinished || $[18] !== shouldRenderBuilderBlocks) {
    t5 = !isCountdownFinished ? <div className="flex flex-row">{shouldRenderBuilderBlocks() ? includedChildren?.map((child, index) => <BuilderBlocks key={index} parentElementId={builderBlock?.id} dataPath={`component.options.includedChildren.${index}.item`} blocks={child.item} className="!flex flex-row! items-center!" style={{
        minHeight: "auto !important"
      }} />) : children}</div> : <span dangerouslySetInnerHTML={{
      __html: completionMessage
    }} className="builder-text" />;
    $[13] = builderBlock?.id;
    $[14] = children;
    $[15] = completionMessage;
    $[16] = includedChildren;
    $[17] = isCountdownFinished;
    $[18] = shouldRenderBuilderBlocks;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4 || $[21] !== t5) {
    t6 = <div><CountdownContext.Provider value={t4}>{t5}</CountdownContext.Provider></div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}